import React from 'react';
import AdminLogin from '../../../Components/Login/AdminLogin';

const AdminLoginPage = () => {
    return (
        <div>
            <AdminLogin></AdminLogin>
        </div>
    );
};

export default AdminLoginPage;